import { render } from "./WordHunt.vue?vue&type=template&id=27f7ce5e&scoped=true"
import script from "./WordHunt.vue?vue&type=script&lang=js"
export * from "./WordHunt.vue?vue&type=script&lang=js"

import "./WordHunt.vue?vue&type=style&index=0&id=27f7ce5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f7ce5e"]])

export default __exports__